import { View, Text, Linking, Platform } from 'react-native'
import React, { useEffect } from 'react'
import ScreenWrapper from '@app/hoc/ScreenWrapper'
import { ThemedText, ThemedView } from '@app/theme'
import LottieView from 'lottie-react-native'
import { NativeStackNavigationProp, NativeStackScreenProps } from '@react-navigation/native-stack'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { isIframe } from '@app/utils/utils'
import axios from 'axios'
import { endpoints } from '@app/api/apis'
import { useAppDispatch, useAppSelector } from '@app/store/hooks'
import { getApplicationId } from '../FetchPortfolio/utils'
import handleApiErr from '@app/helper/handleApiErr'
import { showErrorSheet } from '@app/store/slices/errorSlice'
import { checkDigioMandateStatusTataApi } from '../DigioMandate/digioMandateSignService'
import { useNavigation } from '@react-navigation/native'
import ROUTE from '@app/navigationApp/routes'
import { updateLinkedApplication } from '@app/store/slices/authSlice'

const LIST_ITEMS = [
    {
        title: 'You will be redirected to the bank page',
    },
    {
        title: 'Approve AutoPay using bank details',
    },
    {
        title: 'You will be redirected back to continue',
    }
]

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'DIGIO_AUTOPAY_INPROGRESS'>;
export enum TATA_MANDATE_STATUS {
    FINISHED = 'Finished',
    IN_PROGRESS = 'In Progress'
}


const DigioAutoPayProgress = ({ navigation, route }: ScreenProps) => {
    const { targetUrl } = route.params;
    const { userDetails } = useAppSelector(state => state.auth)
    const dispatch = useAppDispatch();
    let popupWindow: WindowProxy | null = null;
    let tataMandateInterval: NodeJS.Timeout | null = null;

    const runPollarTataMandate = async () => {
        try{
            const response = await checkDigioMandateStatusTataApi({applicationId: userDetails?.linkedApplications[0]?.applicationId})
            const status = response?.data?.stepResponseObject?.status;
            console.log('status', status, TATA_MANDATE_STATUS.IN_PROGRESS);
            if(status !== TATA_MANDATE_STATUS.IN_PROGRESS) {
                if(Platform.OS === 'web') {
                    //SEND MESSAGE TO NATIVE SDK TO CLOSE POP UP WINDOW
                    //@ts-expect-error
                    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
                    //CLOSE POP UP WINDOW
                    popupWindow && popupWindow?.close();
                    tataMandateInterval && clearInterval(tataMandateInterval as NodeJS.Timeout);
                    if(status === TATA_MANDATE_STATUS.FINISHED) {
                        dispatch(updateLinkedApplication(response?.data?.updatedApplicationObj))
                        navigation.navigate(
                            ROUTE.DIGIO_MANDATE_SIGN, 
                            {isSuccessFromRedirect: true}
                        );
                    }
                }
            }
        } catch(error: any) {
            if(handleApiErr(error)) {
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: error?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                    showErrorHeading: true,
                    errorHeading: error?.data?.header,
                    btnName:'Go back',
                }))
            }
        }
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (Platform.OS === 'web') {
                if(isIframe()) {
                    const width = 504;
                    const height = 704;
                    const left = (window.innerWidth - width) / 2;
                    const top = (window.innerHeight - height) / 2;
                    popupWindow = window.open(targetUrl, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                    if(popupWindow) {
                        popupWindow.focus();
                    }
                    tataMandateInterval = setInterval(() => {
                        runPollarTataMandate();
                    }, 3000);
                } else {
                    window.open(targetUrl, '_self');
                }
            } else {
                if (targetUrl) {
                    Linking.openURL(targetUrl);
                }
            }
        }, 3000);

        return () => {
            clearTimeout(timeout);
        };
    }, [targetUrl]);




    return (
        <ScreenWrapper>
            <ThemedView alignItems='center' justifyContent='center' flex={1} bg='bg-surface-primary'>
                <LottieView
                    source={require('../../assets/lottie/sand_timer.json')}
                    style={{
                        width: 100,
                        height: 100,
                    }}
                    autoPlay={true}
                    loop={true}
                />
                <ThemedText mb='2xl' variant='b3b' color='text-primary'>Waiting for AutoPay completion</ThemedText>
                <ThemedView>
                    {LIST_ITEMS.map((item, index) => (
                        <ThemedView mb='lg' key={index} flexDirection='row' alignItems='center'>
                            <ThemedView bg='bg-surface-secondary' borderRadius='full' height={24} width={24} justifyContent='center' alignItems='center' mr='md'>
                                <ThemedText variant='b4r' color='text-primary'>
                                    {index + 1}
                                </ThemedText>
                            </ThemedView>
                            <ThemedText variant='b4r' color='text-primary' textAlign='left'>{item.title}</ThemedText>
                        </ThemedView>
                    ))}
                </ThemedView>
            </ThemedView>
        </ScreenWrapper>
    )
}

export default DigioAutoPayProgress